document.addEventListener('DOMContentLoaded', function () {
  const backToTop = document.querySelector('.back_to_top')
  if (!backToTop) return

  function toggleBackToTop() {
    const threshold = window.innerHeight * 0.8
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    backToTop.classList.toggle('is-current', scrollTop > threshold)
  }

  backToTop.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })

  toggleBackToTop()
  window.addEventListener('scroll', toggleBackToTop, { passive: true })
  window.addEventListener('resize', toggleBackToTop)
})